import axios from 'axios'
import Env from './env'

const AUTH_KEY = 'bunande_auth'
const client = axios.create({
  baseURL: Env.serverIp.replace(/\/$/, ''),
})

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_KEY)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      location.href = '/auth'
    }
    return Promise.reject(err)
  }
)

function withRealName(job) {
  if (!job || typeof job !== 'object') {
    return job
  }
  if (!job.real_name) {
    job.real_name = (job.staff && job.staff.name) || job.contract_main_name || ''
  }
  return job
}

function mapJobs(list) {
  return (list || []).map(withRealName)
}

export function login(username, password) {
  return client.post('/api/auth/login', { username, password }).then((r) => r.data)
}

export function getMe() {
  return client.get('/api/auth/me').then((r) => r.data)
}

export function resetPassword(oldPassword, newPassword) {
  return client
    .post('/api/auth/password', { old_password: oldPassword, new_password: newPassword })
    .then((r) => r.data)
}

export function getDashboardStats() {
  return client.get('/api/dashboard/stats').then((r) => r.data)
}

export function listJobs(params) {
  return client.get('/api/jobs', { params }).then((r) => {
    const body = r.data
    if (body.result && body.result.data) {
      body.result.data = mapJobs(body.result.data)
    }
    return body
  })
}

export function listPendingJobs() {
  return listJobs({ pageNo: 1, pageSize: 50, contract_state: '2' })
}

export function getJob(id) {
  return client.get(`/api/jobs/${id}`).then((r) => r.data)
}

export function createJob(data) {
  return client.post('/api/jobs', data).then((r) => r.data)
}

export function updateJob(id, data) {
  return client.put(`/api/jobs/${id}`, data).then((r) => r.data)
}

export function saveJobDocument(id, data) {
  return client.post(`/api/jobs/${id}/document`, data).then((r) => r.data)
}

export function submitJob(id, data) {
  return client.post(`/api/jobs/${id}/submit`, data).then((r) => r.data)
}

export function copyJob(id) {
  return client.post(`/api/jobs/${id}/copy`).then((r) => r.data)
}

export function cancelJob(id) {
  return client.post(`/api/jobs/${id}/cancel`).then((r) => r.data)
}

export function deleteJob(id) {
  return client.post(`/api/jobs/${id}/delete`).then((r) => r.data)
}

export function syncJobStatus(id) {
  return client.post(`/api/jobs/${id}/sync-status`).then((r) => r.data)
}

export function resendJob(id) {
  return client.post(`/api/jobs/${id}/resend`).then((r) => r.data)
}

export function resendInvalidJob(id) {
  return client.post(`/api/jobs/${id}/resend-invalid`).then((r) => r.data)
}

export function previewJob(id) {
  return client.get(`/api/jobs/${id}/preview`).then((r) => r.data)
}

export function uploadFile(formData) {
  return client.post('/api/uploads', formData).then((r) => r.data)
}

export function listStaff(params) {
  return client.get('/api/staff', { params }).then((r) => r.data)
}

export function saveStaff(data) {
  return client.post('/api/staff', data).then((r) => r.data)
}

export function addStaffQuota(data) {
  return client.post('/api/staff/contract-quota', data).then((r) => r.data)
}

export function setAuth(value) {
  if (value === '' || value == null) {
    localStorage.removeItem(AUTH_KEY)
    return
  }
  localStorage.setItem(AUTH_KEY, String(value))
}

export function getAuth() {
  return localStorage.getItem(AUTH_KEY) || ''
}

export default client
